export default "__VITE_ASSET__ad0bb065__"